import { render, staticRenderFns } from "./ClipboardArrowLeftOutline.vue?vue&type=template&id=126c31c6&"
import script from "./ClipboardArrowLeftOutline.vue?vue&type=script&lang=js&"
export * from "./ClipboardArrowLeftOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports